import { ReactNode, useMemo, useState } from "react";

import UsedByPanel from "~/components/usedBy/UsedByPanel";
import { type UsedBySubject } from "~/components/usedBy/usedByHelpers";
import UsedByPanelContext from "~/providers/UsedByPanelContext";

interface UsedByPanelProviderProps {
	children: ReactNode;
}

const UsedByPanelProvider = ({ children }: UsedByPanelProviderProps) => {
	const [subject, setSubject] = useState<null | UsedBySubject>(null);
	const usedByPanelContextValue = useMemo(() => ({ openUsedBy: setSubject }), []);

	return (
		<UsedByPanelContext.Provider value={usedByPanelContextValue}>
			{children}
			<UsedByPanel onClose={() => setSubject(null)} subject={subject} />
		</UsedByPanelContext.Provider>
	);
};

export default UsedByPanelProvider;
